import React from 'react';
import { useCompanyIcon } from '../../hooks/useCompanyIcon.js';

const OnPowerLogoIcon = ({ className = '', size = 'default' }) => {
  const iconUrl = useCompanyIcon();

  const sizeClasses = {
    small: 'w-6 h-6',
    default: 'w-8 h-8',
    medium: 'w-10 h-10',
    large: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <div className={`${sizeClasses[size]} flex-shrink-0 ${className}`}>
      <img
        src={iconUrl || '/generic-logo-white.png'}
        alt="Logo de la empresa"
        className="w-full h-full object-contain"
      />
    </div>
  );
};

export default OnPowerLogoIcon; 